import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { addToCart } from "../redux/shopSlice";
import { ToastContainer, toast } from 'react-toastify';
import './toast.css'

function Product() {
  const dispatch = useDispatch();
  const [details, setDetails] = useState({});

  let [baseQty, setBaseQty] = useState(parseInt(1));
  const location = useLocation();

  useEffect(() => {
  

    // Check if location.state.item is truthy before setting the details state
    if (location.state && location.state.item) {
      // If details are not found in localStorage, set the state from location.state.item
      setDetails(location.state.item);
      console.log('param',location.state.item);
    } else {
      // Try to get the details from localStorage
      const storedDetails = localStorage.getItem("details");
      if (storedDetails) {
        // If details are found in localStorage, parse and set the state
        setDetails(JSON.parse(storedDetails));
        console.log(storedDetails, 'localStorage');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Update localStorage whenever details state changes
  useEffect(() => {
    localStorage.setItem("details", JSON.stringify(details));
    /* return () => {
      // Remove the itemDetails data from local storage when the component unmounts
      localStorage.removeItem("itemDetails");
    }; */
  }, [details]);

  console.log(details)


  /*const [prod,setProd] =useState({})
   const productData = useSelector((state) => state.shopsyReducer.productData)
  const pdata = productData.find(
    (data)=> data._id === details.id
  )
  console.log(pdata); */

  return (
    <div>
      <div className="py-6 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center space-x-2 text-gray-400 text-sm">
            <Link to={'/'} className="hover:underline hover:text-gray-600">
              Home
            </Link>
            <span>
              <svg
                className="h-5 w-5 leading-none text-gray-300"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </span>
            <Link to={'/'} className="hover:underline hover:text-gray-600">
              Category
            </Link>
            <span>
              <svg
                className="h-5 w-5 leading-none text-gray-300"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </span>
            <span>Sub</span>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:pt-5 lg:px-8 mt-6">
          <div className="flex flex-col md:flex-row -mx-4">
            <div className="md:flex-1 px-4">
              <div
                x-data="{ image: 1 }"
                x-cloak
                className="flex items-center justify-center pr-4 lg:py-5 lg:h-4/5"
              >
                <img
                  className="h-64 md:h-96 rounded-xl bg-slate-300 mb-4"
                  src={details.image}
                  alt="Product_Image"
                />

                <div className="flex -mx-2 mb-4"></div>
              </div>
            </div>
            <div className="md:flex-1 px-4">
              <h2 className="mb-2 leading-tight tracking-tight font-bold text-gray-800 text-2xl md:text-3xl">
                {details.title}
              </h2>
              <p className="text-gray-500 text-sm">
                By{" "}
                <Link href="#" className="text-purple-800 hover:underline">
                  Shopsyi
                </Link>
              </p>

              <div className="flex items-center space-x-4 my-4">
                <div>
                  <div className="rounded-lg bg-gray-100 flex py-2 px-3">
                    <span className="font-bold text-yellow-600  text-3xl">
                      {details.price}&pi;
                    </span>
                  </div>
                </div>
              </div>

             

              <div className="flex py-4 space-x-4">
                <div className="relative">
                  
                  {/* <div className='w-18  items-center justify-between bg-slate-800  text-slate-200 gap-3 border rounded-xl border-gray-800 p-1'>
                <div className='items-center justify-center text-slate-400 px-7'>
                <p className="text-sm ">QTY</p></div>
                <div className='flex items-center gap-3 text-sm font-semibold'>
                <button className='border border-slate-600 h-5 font-normal text-lg flex items-center justify-center px-2
                 hover:bg-slate-900 hover:text-slate-100 cursor-pointer duration-300 active:bg-purple-500 rounded-md'>-</button>
                <span className='border rounded-md border-slate-600 p-1 bg-slate-700 font-semibold'>{3}</span>
                <button className='border border-slate-600 h-5 font-normal text-lg flex items-center justify-center px-2
                 hover:bg-slate-900 hover:text-slate-100 cursor-pointer duration-300 active:bg-purple-500 rounded-md'>+</button>
                </div>
            </div> */}
                  {/*  */}

                  <div className="text-center left-0 pt-2 right-0 absolute block text-xs uppercase text-purple-200 text-opacity-60 tracking-wide font-semibold">
                    Qty
                  </div>
                  <select
                    className="cursor-pointer appearance-none rounded-xl border border-gray-200 pl-4 pr-8 h-14 flex items-end pb-1 bg-slate-800 text-purple-300 font-semibold"
                    value={baseQty}
                    onChange={(e) => setBaseQty(parseInt(e.target.value))}
                  >
                    <option value={1}>1</option>
                    <option value={2}>2</option>
                    <option value={3}>3</option>
                    <option value={4}>4</option>
                    <option value={5}>5</option>
                  </select>

                  <svg
                    className="w-5 h-5 text-purple-200 text-opacity-60 absolute right-0 bottom-0 mb-2 mr-2"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M8 9l4-4 4 4m0 6l-4 4-4-4"
                    />
                  </svg>
                </div>

                <button
                  type="button"
                  className="h-14 px-6 py-2 font-semibold rounded-xl active:scale-105 duration-100 bg-slate-800 active:bg-slate-900 text-purple-300 group cursor-auto"
                  onClick={() =>
                    dispatch(
                      addToCart({
                        id: details.id,
                        title: details.title,
                        image: details.image,
                        price: details.price,
                        quantity: baseQty,
                      })
                    ) & toast.success(`${details.title} is added to Cart`) 
                    
                  }
                >
                  <span className="group-active:text-indigo-200 duration-500"> Add to Cart </span> 
                </button>
                {/* <button type="button" className="h-14 px-6 py-2 font-semibold rounded-xl bg-slate-900 hover:bg-indigo-500 text-purple-300">
            Buy Now
          </button> */}
              </div>
            </div>

               <p className="text-gray-500 mx-3">
                {details.description}
              </p>


          </div>
            
        </div>
      </div>
      <ToastContainer
        position="top-left"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        toastClassName="custom-toast-background"
      />
      {/* <div className="grid lg:grid-cols-2">
            <div className="image p-4">
                <img src={details.image} alt="product_image" />
            </div>
            <div className="description">

            </div>
        </div>
         */}
    </div>
  );
}

export default Product;
